import { all, put, takeEvery } from 'redux-saga/effects';
import { reset as reduxFormReset } from 'redux-form/immutable';

import { CREATE } from './actions';

function* createSucceeded({ payload: { form } }) {
  // Note: This should be deleted, but might have consequences for resource/customer
  // views.
  if (form) {
    yield put(reduxFormReset(form));
  }
}

export default function* defaultSaga() {
  yield all([
    takeEvery(CREATE.SUCCESS, createSucceeded),
  ]);
}
